import React, { useState, useEffect } from "react";
import moment from "moment";
import classess from "./countDown.module.css";

export default function CountdownTimer({ endTime, isStore, discountPercentage }) {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = moment();
      const end = moment(endTime);
      const duration = moment.duration(end.diff(now));

      if (duration.asSeconds() <= 0) {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      } else {
        setTimeLeft({
          days: Math.floor(duration.asDays()),
          hours: duration.hours(),
          minutes: duration.minutes(),
          seconds: duration.seconds(),
        });
      }
    };

    calculateTimeLeft();

    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [endTime]);

  const endDate = moment(endTime);
  const dayOfWeek = endDate.format("dddd").toUpperCase();

  const isLessThan7Days = timeLeft.days < 7;

  const formattedDate = endDate.format("MMMM Do");

  return (
    <>
    {moment(endTime).isValid() ? (
      <div className={classess.countdown_container}>
        <div className={`${classess.countdown_item} ${classess.title}`}>
          <div className={`${classess.countdown_value} ${classess.days_value}`}>
            {isStore && "SALE ENDS IN"}
          </div>
        </div>
        <div className={classess.countdown_timer}>
          <div className={classess.countdown_item}>
            <div className={classess.countdown_value}>
              {String(timeLeft.days).padStart(2, "0")} :
            </div>
            <div className={classess.countdown_label}>Days</div>
          </div>
          <div className={classess.countdown_item}>
            <div className={classess.countdown_value}>
              {String(timeLeft.hours).padStart(2, "0")} :
            </div>
            <div className={classess.countdown_label}>Hours</div>
          </div>
          <div className={classess.countdown_item}>
            <div className={classess.countdown_value}>
              {String(timeLeft.minutes).padStart(2, "0")}
            </div>
            <div className={classess.countdown_label}>Mins</div>
          </div>
        </div>
      </div>
    ) : (
      <div className={classess.countdown_container}>
        <div className={`${classess.countdown_item} ${classess.title}`}>
          <div className={`${classess.countdown_value} ${classess.days_value}`}>SALE</div>
        </div>
      </div>
    )}
  </>
  );
}
